<template>
  <div class="index">
    <span class="font">欢迎来到3699-BI数据分析与可视化平台!</span>
  </div>
</template>

<script>
export default {
  name: "VueprojectHello",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0;
}
.index {
  width: 100%;
  height: 100%;
  background-image: url("../../static/das.67f81ac6.png");
  position: relative;
  .font {
    font-size: 60px;
    background-image: linear-gradient(135deg, red, blue);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    font-style: italic;
    position: absolute;
    top: 20px;
    left: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Hello.vue